import React from 'react'
import { ContextLoader } from '../../../utils/import.frames';

import close from './../../../UI/icons/Galerias/Close.svg'
import next from './../../../UI/icons/Galerias/next.svg'
import prev from './../../../UI/icons/Galerias/prev.svg'

interface Props {
    isTerreno: boolean,
    handleCloseTerreno: any,
}

interface State {
    currentImage: string,
    currentImageIndex: number
}

class Terreno extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = ({
            currentImage: "",
            currentImageIndex: 0
        })
    }

    componentDidMount(): void {
        this.setState({
            currentImage: ContextLoader["Terreno"]()[this.state.currentImageIndex]
        })
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        
    }

    handleNextImage = () => {
        this.state.currentImageIndex + 1 > ContextLoader["Terreno"]().length - 1 ? this.setState({currentImageIndex: 0}):this.setState({currentImageIndex: this.state.currentImageIndex + 1})
    }

    handlePrevImage = () => {
        this.state.currentImageIndex - 1 < 0 ? this.setState({currentImageIndex: ContextLoader["Terreno"]().length - 1}):this.setState({currentImageIndex: this.state.currentImageIndex - 1})
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isTerreno ? 'terreno-container fade-in':'terreno-container fade-out'}>
                {
                    this.props.isTerreno ?
                    <img src={ContextLoader["Terreno"]()[this.state.currentImageIndex]} className="preview-image"/>:null
                }
                <div className="next-gallery" onClick={() => {this.handleNextImage()}}>
                    <img src={next}></img>
                </div>
                <div className="previous-gallery" onClick={() => {this.handlePrevImage()}}>
                    <img src={prev}></img>
                </div>
                <div className="close-gallery" onClick={() => {this.props.handleCloseTerreno()}}>
                    <img src={close}></img>
                </div>
            </div>
        )
    }
}

export default Terreno